(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowStepEditor', drvWorkflowStepEditor);

    drvWorkflowStepEditor.$inject = [];
    
    function drvWorkflowStepEditor () {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                step: '=',
                workflowApi: '='
            },
            controller: controller,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'app/workflow/workflow-step-editor.tmpl.html'
        };
        return directive;

        function link(scope, element, attrs) {
        }

        function controller() {
        }
    }
})();